import { assert } from '@ember/debug';
import Component from '@glimmer/component';
const ALLOWED_COLORS = ['red', 'green', 'orange', 'purple', 'gray'];
export default class StatusTagComponent extends Component {
  constructor() {
    super(...arguments);
    assert('<StatusTag /> must have a @text', this.args.text);
  }
  get color() {
    let color = this.args.color ?? 'gray';
    assert('<StatusTag /> can only have those colors: red, green, orange, purple or gray', ALLOWED_COLORS.includes(color));
    return color;
  }
}